/*
 * ENDPOINT DESCRIPTIONS ARE LOCATED ABOVE THE ENDPOINT
 * */
const ENDPOINTS = {
  CUSTOMERS: {},
  USERS: {},
  EVENTS: {
    GET_TICKET_PDF: '/registrants/ticketManager/tickets',
    /**
     * GET CALL -- fetches config for static output
     * query: event_id
     * NO COOKIE WILL BE IN THE HEADER SINCE THIS IS PUBLIC
     * return eventPageConfiguration.contracts.js
     * */
    //IMPLEMENTED
    GET_EVENT_PAGE_CONFIG: '/events/public-page/config',
    /**
     * POST CALL -- tracks event sponsor impressions and clicks
     * query: event_id
     * body: {
     *   sponsor_id:1,
     *   type: ENUM(click, impression)
     * }
     * return 200/400 --> this is actually a background action that will never be displayed. This status will do nothing in the front end , it's here for logging purposes for the backend
     * */
    //IMPLEMENTED
    UPDATE_SPONSOR_TRACKING: '/events/public-page/sponsors',
    /**
     * GET CALL - get all tickets/tables to be displayed in the selection screen
     * query: event_id,
     * return eventTicketSelection.contracts.js --> return 410 if event is closed
     * */
    //IMPLEMENTED
    GET_ALL_SELECTIONS: '/events/public-page/selections',
    GET_PREPAID_SELECTIONS: '/events/public-page/prepaid-selections',
    /**
     * GET CALL -- get config for the closed registration page
     * query: event_id,
     * return eventPageClosedConfiguration.contracts.js
     * */
    //TODO:CW
    GET_CLOSED_REGISTRATION_CONFIG: '/events/public-page/closed-registration',
    /**
     * GET CALL -- get config for decline invitation page
     * query: event_id
     * return eventPageClosedConfig.contracts.js (same shape)
     * */
    //TODO:CW
    GET_DECLINE_INVITATION_CONFIG: '/events/public-page/decline-invitation',
    /**
     * POST CALL -- sends order to backend for calculations
     * query: event_id
     * body:{
     *    sponsor:{ --> may be null
     *      first_name,
     *      last_name,
     *      email,
     *      phone_number,
     *      org_name,
     *      org_logo
     *    },
     *    is_group_host:false
     *   table_id: [1]
     *   tickets:[
     *    {
     *      ticket_id: 1,
     *      ticket_count,
     *      registrations:[{
     *                first_name,
     *      last_name,
     *      ticket_price: ===> will only be here if if ticket type is of donation
     *      email,
     *      phone_number,
     *      phone_code:1, --> hardcoded to 1 for now
     *      affiliation,
     *      registration_request,
     *           custom_questions:[
     *        {
     *          id,
     *          value
     *        }
     *      ],add_ons:[
     *        {
     *          id,
     *          is_included: false/false
     *          variant:{ --> may be null
     *            id,
     *          },
     *          custom_questions:[
     *          {
     *            id,
     *            value
     *          }],
     *     }]
     *      }
     *
     *   ]}]
     * }
     * returns {
     *   cart_id
     * }
     * */
    //IMPLEMENTED
    POST_ORDER_DETAILS: '/events/public-page/order',
    /**
     * GET CALL -- get order summary
     * query: event_id,cart_id
     * return orderDetailsSummary.contracts.js
     * */
    //IMPLEMENTED
    GET_ORDER_SUMMARY: '/events/public-page/order',
    /**
     * POST CALL - recalculate order summary based on discount code
     * query: event_id
     * body:{
     *   cart_id,
     *   discount_code
     * }
     * return eventRecalcOrder.contracts.js
     * */
    //IMPLEMENTED
    POST_RECALC_SUMMARY: '/events/public-page/recalc-order',
    /**
     * POST CALL -- submit order payment
     * query: event_id
     * body:{
     *   cart_id,
     *   email
     *   phone_number
     *   phone_code
     *   discount_code
     *   type: selection from allowed processors --> if type is offline then card information wont be there
     *   card_number
     *   exp_date
     *   cvc
     *   name_on_card
     *   country
     *   postal_code
     * }
     * return 200/400
     * */
    //TODO:CW
    POST_EVENT_PAYMENT: '/events/public-page/payment',
    POST_EVENT_HOSTED_PAYMENT:
      '/events/public-page/hostedPayment' /* hopefully temporary. Use this to load stripe iframe */,
    /**
     * GET CALL -- get registration complete config
     * query: event_id
     * return eventPageClosedConfig.contracts.js (same shape)
     * */
    //TODO:CW
    GET_CONFIRMATION_CONFIG: '/events/public-page/confirmation',
    /**
     * POST CALL -- add to wait list
     * query:event_id
     * return 200/400
     * */
    //TODO:CW
    ADD_TO_WAIT_LIST: '/events/public-page/wait-list',
    /**
     * GET CALL -- get all ticket configs for an order
     * query: event_id, ticket_id ==> may have more than one ticket_id
     * return eventTicketConfig.contracts.js
     * */
    //TODO:CW
    GET_ORDER_TICKET_CONFIG: '/events/public-page/ticket-config',

    /**
     * GET CALL -- get all ticket configs for an order
     * query: event_id, ticket_id ==> may have more than one ticket_id
     * return eventTicketConfig.contracts.js
     * */
    //TODO:CW
    GET_PREPAID_TICKET_CONFIG: '/events/public-page/prepaid-ticket-config',



    /**
     * GET CALL -- get all ticket configs for an order
     * query: event_id, token
     * return [
     *   {...ticket-config}
     * ]
     * */
    //TODO:CW
    GET_PREPAID_TICKETS_RECORD_INFO: '/events/public-page/prepaid-tickets',
    /**
     * GET CALL -- get all ticket configs for an order
     * query: event_id, token
     * return [
     *   {...ticket-config}
     * ]
     * */
    //TODO:CW
    UPSERT_PREPAID_TICKETS: '/events/public-page/claim-prepaid-tickets',
    /**
     * GET CALL -- get config for express check in page
     * query: event_id
     * return eventPageClosedConfig.contracts.js (same shape)
     * */
    //TODO:CW
    GET_EXPRESS_CHECKIN_CONFIG: '/events/public-page/express-checkin',
    /**
     * GET CALL -- get registrants based on email
     * query: event_id, email
     * return [
     * {id, first_name, last_name, email}
     * ]
     * */
    //TODO:CW
    GET_EXPRESS_CHECKIN_LIST: '/events/public-page/express-checkin/list',
    /**
     * POST CALL -- post express checkin
     * query: event_id
     * body:[reg_id]
     * */
    //TODO:CW
    POST_EXPRESS_CHECKIN: '/events/public-page/express-checkin/',
    /**
     * POST CALL -- Decline inviation
     * query: event_id
     * body:{
     *     invitation_id:1,
     *     wont_attend: false,
     *     first_name:'Max',
     *     last_name:'T',
     *     email:test@test.com,
     *     phone: 7777777777
     * }
     * */
    //TODO:AJAY
    POST_DECLINE_INVITATION: '/events/public-page/decline-invitation',
    /*
     * GET CALL -- get configs for sponsor tier
     * query: event_id
     * return [
     * {
     *   id:1,
     *   name: 'tier 1',
     *   price: 1000,
     *   description: 'This is a sponsor description'
     * }
     * ]
     * **/
    GET_SPONSOR_TIERS: '/events/public-page/get-sponsor-configs',
    /**
     * POST CALL - post sponsor registration order (creates cart_id)
     * query: event_id
     * body:{
     *     first_name,
     *     last_name,
     *     email,
     *     sponsor_name,
     *     sponsor_tier_id,
     *     sponsor_website,
     *     sponsor_photo:{
     *         imgBase64, fileType
     *     },
     *     is_annon
     * }
     * return cart_id
     * */

    SPONSPOR_PROFILE: '/events/public-page/sponsors/profile',
    POST_SPONSOR_REGISTRATION_ORDER: '/events/public-page/sponsor-order',
    SEND_PEER_INVITATIONS: '/events/invitations/peer/send',
    ACCEPT_INVITATION: '/events/invites/accept',
    DECLINE_INVITATION: '/events/invites/decline',
    GET_INVITATION_DETAILS: '/events/invite/details',
    GET_INVITATION_DETAILS_BY_INVITE_CODE: '/events/invite/details/invite-code',
    CONFIRM_INVITATION: '/events/invitation/confirm',
    /**
     * GET CALL -- fetches list of event registrants identified as liaisons
     * query: event_id
     *
     * return eventLiaisons.contracts.js
     * */
    //IMPLEMENTED
    GET_EVENT_PAGE_LIAISONS: '/events/public-page/liaisons',
    /**
     * GET CALL -- fetches list of event groups
     * query: event_id
     *
     * return eventGroups.contracts.js
     * */
    //IMPLEMENTED
    GET_EVENT_PAGE_GROUPS: '/events/public-page/groups',
    /**
     * POST CALL -- validates if name of group on event is taken
     * query: event_id
     * BODY: { name: string }
     *
     * return {
     *  200: "Group Name is available."
     *  400: "Group Name is unavailable."
     * }
     * */
    //IMPLEMENTED
    POST_VALIDATE_GROUP_NAME: '/events/public-page/groups/check-name',
    POST_VALIDATE_AFFILIATION_NAME: '/events/public-page/affiliations/check-affiliation-name',
    CREATE_AFFILIATION: '/events/public-page/affiliations/create',
    GET_AFFILIATIONS: '/events/public-page/affiliations/list',
    GET_FORM_VISIBILITY: "/events/public-page/sponsor-form-visibility",
    GET_FUNDRAISER_PAGE_INFO:"/events/public-page/fundraiser-page",
    GET_FUNDRAISER_URL: '/events/public-page/fundraiser-url',
    GET_FUNDRAISER_GROUP_URL: '/events/public-page/fundraiser-group-url',
    P2P_LOGIN:"/events/public-page/login",
    P2P_ACCOUNT_CREATE:"/events/public-page/login/create",
    P2P_PUBLISH_UPDATE:"/events/public-page/updates-upsert",
    UPSERT_FUNDRAISER_PAGE_INFO:"/events/public-page/page-info-upsert",
    UPSERT_DONOR_MANUALLY:'/events/public-page/upsert-donor',
    UPSERT_PROFILE:'/events/public-page/upsert-profile',
    DELETE_P2P_UPDATES:'/events/public-page/p2p-update',
    P2P_CREATE_TEAM:'/events/public-page/create-team',
    GET_TEAMS:'/events/public-page/teams',
    JOIN_TEAM:'/events/public-page/teams',
    JOIN_TEAM_UNAUTHORIZED:'/events/public-page/teams-unauthorized',
    LEAVE_TEAM:'/events/public-page/leave-team',
    UPDATE_P2P_STAT:'/events/public-page/page-stat',
    UPLOAD_P2P_PROFILE_IMG:'/events/public-page/upload-p2p-profile-img',
    POST_DONATION:'/events/post-donations',
    POST_CAROUSEL_IMG: '/events/public-page/post-carousel-image',
    DELETE_CAROUSEL_IMG: '/events/public-page/post-carousel-image',
    GET_PARTICIPANT_DONATION_LIST: '/events/public-page/participant-donation-list',
    GET_TEAM_DONATION_LIST:'/events/public-page/team-donation-list',
    RECOVER_PASSWORD_KICKOFF:'/events/public-page/request-password-reset',
    RECOVER_USERNAME:'/events/public-page/request-username',
    RESET_PASSWORD:'/events/public-page/reset-password',
  },
  WEBHOOKS: {},
  META: {
    SETTINGS: '/meta/settings',
  }
}
//Named export for system settings

export default ENDPOINTS
//named export for allowing mockServer to intercept the request or not
//set to false if you want to hit the backend defined in .env
export const ROUTE_MOCKING = {
  // controller mocking flags -- this will turn off/on mocking for whole controller
  CUSTOMERS: false,
  USERS: false,
  META: false,
  EVENTS: false,
  WEBHOOKS: false,
  INTEGRATIONS: false,
  REGISTRANTS: false,
  //individual route mocking

  [ENDPOINTS.EVENTS.GET_TICKET_PDF]: false,
  [ENDPOINTS.EVENTS.GET_EVENT_PAGE_CONFIG]: false,
  [ENDPOINTS.EVENTS.UPDATE_SPONSOR_TRACKING]: false,
  [ENDPOINTS.EVENTS.GET_ALL_SELECTIONS]: false,
  [ENDPOINTS.EVENTS.GET_CLOSED_REGISTRATION_CONFIG]: false,
  [ENDPOINTS.EVENTS.GET_DECLINE_INVITATION_CONFIG]: false,
  [ENDPOINTS.EVENTS.POST_ORDER_DETAILS]: false,
  [ENDPOINTS.EVENTS.GET_ORDER_SUMMARY]: false,
  [ENDPOINTS.EVENTS.POST_RECALC_SUMMARY]: false,
  [ENDPOINTS.EVENTS.POST_EVENT_PAYMENT]: false,
  [ENDPOINTS.EVENTS.GET_CONFIRMATION_CONFIG]: false,
  [ENDPOINTS.EVENTS.ADD_TO_WAIT_LIST]: false,
  [ENDPOINTS.EVENTS.GET_ORDER_TICKET_CONFIG]: false,
  [ENDPOINTS.EVENTS.GET_EXPRESS_CHECKIN_CONFIG]: false,
  [ENDPOINTS.EVENTS.GET_EXPRESS_CHECKIN_LIST]: false,
  [ENDPOINTS.EVENTS.POST_EXPRESS_CHECKIN]: false,
  [ENDPOINTS.EVENTS.POST_DECLINE_INVITATION]: false,
  [ENDPOINTS.EVENTS.GET_SPONSOR_TIERS]: false,
  [ENDPOINTS.EVENTS.POST_SPONSOR_REGISTRATION_ORDER]: false,
  [ENDPOINTS.EVENTS.POST_DECLINE_INVITATION]: false,
  [ENDPOINTS.EVENTS.SEND_PEER_INVITATIONS]: false,
  [ENDPOINTS.EVENTS.DECLINE_INVITATION]: false,
  [ENDPOINTS.EVENTS.ACCEPT_INVITATION]: false,
  [ENDPOINTS.EVENTS.GET_INVITATION_DETAILS]: false,
  [ENDPOINTS.EVENTS.CONFIRM_INVITATION]: false,
  [ENDPOINTS.EVENTS.GET_PREPAID_TICKETS_RECORD_INFO]: false,
  [ENDPOINTS.EVENTS.UPSERT_PREPAID_TICKETS]:false,
  [ENDPOINTS.EVENTS.GET_FUNDRAISER_PAGE_INFO]:false,
  [ENDPOINTS.EVENTS.P2P_LOGIN]:false,
  [ENDPOINTS.EVENTS.P2P_ACCOUNT_CREATE]:false,
  [ENDPOINTS.EVENTS.P2P_PUBLISH_UPDATE]:false,
  [ENDPOINTS.EVENTS.UPSERT_FUNDRAISER_PAGE_INFO]:false,
  [ENDPOINTS.EVENTS.UPSERT_DONOR_MANUALLY]:false,
  [ENDPOINTS.EVENTS.DELETE_P2P_UPDATES]:false,
  [ENDPOINTS.EVENTS.P2P_CREATE_TEAM]:false,
  [ENDPOINTS.EVENTS.GET_TEAMS]:false,
  [ENDPOINTS.EVENTS.JOIN_TEAM]:false,
  [ENDPOINTS.EVENTS.JOIN_TEAM_UNAUTHORIZED]:false,
  [ENDPOINTS.EVENTS.LEAVE_TEAM]:false,
  [ENDPOINTS.EVENTS.UPDATE_P2P_STAT]:false,
  [ENDPOINTS.EVENTS.UPLOAD_P2P_PROFILE_IMG]:false,
  [ENDPOINTS.EVENTS.POST_DONATION]:false,
  [ENDPOINTS.EVENTS.GET_PARTICIPANT_DONATION_LIST]:false,
  [ENDPOINTS.EVENTS.GET_TEAM_DONATION_LIST]:false,
  [ENDPOINTS.EVENTS.RECOVER_PASSWORD_KICKOFF]:false,
  [ENDPOINTS.EVENTS.RECOVER_USERNAME]:false,
  [ENDPOINTS.EVENTS.RESET_PASSWORD]:false,

  [ENDPOINTS.META.FEATURE_FLAGS]:false
}
